import vClickOutside from 'v-click-outside'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import IcArrowDown from '@/assets/svg/ic-arrow-down.svg?inline'

export default {
  name: 'FiltersSelect',
  components: {
    IcArrowDown,
    SelectScrollbar: VuePerfectScrollbar
  },
  props: {
    /**
     * 
     */
    options: {
      type: Array,
      default: () => []
    },
    idField: {
      type: String,
      default: 'id'
    },
    /**
     * Нужно если передаются объекты
     */
    nameField: {
      type: String,
      default: 'title'
    },
    getNameFunc: {
      type: Function
    },
    /**
     * если Array, то это multiple
     * предполагается, что каждый item в options
     * будет объектом с уникальным id
     */
    value: {
      type: Array | String | Number | Object
    },

    isShowSelectAll: {
      type: Boolean,
      default: true
    },
    
    placeholder: {
      type: String,
      default: ''
    },

    searchable: {
      type: Boolean,
      default: false
    },

    emptyValue: {
      default: null
    },

    clearOption: {
      type: Boolean,
      default: true
    },
    /**
     * Поменяем стили, в случае если селект на белом фоне
     */
    whiteBg: {
      type: Boolean,
      default: false
    },

    /**
     * в случае если при !isMultiple
     * требуется отметка все равно чекбоксом
     */
    checkboxSelected: {
      type: Boolean,
      default: false
    },

    /**
     * немного меняет стили toggle
     */

    biggerToggle: {
      type: Boolean,
      default: false
    },

    optionsPosition: {
      type: String,
      default: 'bottom' // bottom || top
    }
  },
  data() {
    return {
      focus: false,
      open: false,
      seachOptions: ''
    }
  },
  computed: {
    optionsFiltered() {
      if (this.seachOptions) {
        return this.options.filter(option => {
          const title = this.getOptionTitle(option)
          return title.toLowerCase().startsWith(this.seachOptions.toLowerCase())
        })
      }
      return this.options
    },
    isMultiple() {
      return Array.isArray(this.value)
    },
    valueString() {
      let result = ''
      if (this.isMultiple) {
        result = this.value
          .map(item => this.getOptionTitle(item))
          .join(', ')
      } else {
        result = this.seachOptions ? this.seachOptions : this.getOptionTitle(this.value)
      }
      return result
    }
  },
  methods: {
    getOptionTitle(item) {
      if (this.getNameFunc) {
        return this.getNameFunc(item)
      }
      if (item !== null && typeof item === 'object') {
        return item[this.nameField]
      }
      return item !== null ? item : ''
    },
    onClickOption(item) {
      if (this.isMultiple) {
        if (this.value.find(valueItem => valueItem[this.idField] === item[this.idField]) !== undefined) {
          this.$emit('input', this.value.filter(valueItem => valueItem[this.idField] !== item[this.idField]))
        } else {
          this.$emit('input', [...this.value, item])
        }
      } else {
        this.$emit('input', item)
        this.open = false
        this.seachOptions = ''
      }
    },
    getOptionChecked(option) {
      if (this.isMultiple) {
        return this.value.find(valueItem => valueItem[this.idField] === option[this.idField]) !== undefined
      }
      return this.getOptionSelected(option)
    },
    getOptionSelected(option) {
      if (this.value !== this.emptyValue) {
        if (typeof option === 'object') {
          return option[this.idField] === this.value[this.idField]
        }
        return option === this.value
      }
      return false
    },
    onClickOutside() {
      this.open = false
      this.seachOptions = ''
    },
    onCheckAll() {
      if (this.value.length < this.options.length) {
        this.$emit('input', [ ...this.options ])
      } else {
        this.$emit('input', [])
      }
    },
    onNotSelect() {
      this.$emit('input', this.emptyValue)
    },
    onFocus() {
      this.focus = true
    },
    onBlur() {
      this.focus = false
    },
    onClickToggle() {
      this.open = !this.open
    },
    onClickArrow() {
      this.$refs['select-input'].focus()
    },
    onKeypress(e) {
      if (this.isMultiple || !this.searchable) {
        e.preventDefault()
      }
    },
    onKeyup(e) {
      if (!this.isMultiple && this.searchable) {
        this.seachOptions = e.target.value
      }
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  }
}